var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0915 1.53077C11.7011 1.23904 11.5059 1.09318 11.2904 1.03711C11.1002 0.987632 10.8998 0.987632 10.7096 1.03711C10.4941 1.09318 10.2989 1.23904 9.90855 1.53077L2.37266 7.16264C1.86891 7.53911 1.61704 7.72734 1.43559 7.96307C1.27485 8.17189 1.15511 8.40713 1.08225 8.65724C1 8.93959 1 9.24619 1 9.85939V17.5836C1 18.7794 1 19.3774 1.24221 19.8341C1.45526 20.2359 1.79522 20.5626 2.21335 20.7673C2.68871 21 3.31099 21 4.55556 21H6.77778C7.08892 21 7.24449 21 7.36333 20.9418C7.46786 20.8906 7.55285 20.809 7.60612 20.7085C7.66667 20.5943 7.66667 20.4449 7.66667 20.1459V13.0996C7.66667 12.5016 7.66667 12.2027 7.78777 11.9743C7.8943 11.7734 8.06428 11.6101 8.27334 11.5077C8.51102 11.3914 8.82216 11.3914 9.44444 11.3914H12.5556C13.1778 11.3914 13.489 11.3914 13.7267 11.5077C13.9357 11.6101 14.1057 11.7734 14.2122 11.9743C14.3333 12.2027 14.3333 12.5016 14.3333 13.0996V20.1459C14.3333 20.4449 14.3333 20.5943 14.3939 20.7085C14.4471 20.809 14.5321 20.8906 14.6367 20.9418C14.7555 21 14.9111 21 15.2222 21H17.4444C18.689 21 19.3113 21 19.7866 20.7673C20.2048 20.5626 20.5447 20.2359 20.7578 19.8341C21 19.3774 21 18.7794 21 17.5836V9.85939C21 9.24619 21 8.93959 20.9177 8.65724C20.8449 8.40713 20.7252 8.17189 20.5644 7.96307C20.383 7.72734 20.1311 7.53911 19.6273 7.16264L12.0915 1.53077Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.517905d4f0f5b3b4299c367d99f740b0.svg";
export { ForwardRef as ReactComponent };